'use strict';

var React = require('react');
var ReactDOM = require('react-dom');
var appTypes = require('../../types/appTypes');
var styleHelper = require('../../helper/styleHelper');
var propConst = require('../../constants/propConst');

var PointyButton = React.createClass({
  componentWillUnmount : function(){
    if(this.requestID){
      cancelAnimationFrame(this.requestID);
    }
  },

  paintBorder: function () {
    var props = this.props;
    var ctx = ReactDOM.findDOMNode(this.refs.ctx).getContext('2d');
    var direction = parseInt(this.props.direction, 10);
    var bg = styleHelper.getBackgroundColor(this.props);
    var w = styleHelper.getWidth(this.props);
    var h = styleHelper.getHeight(this.props);
    var radius = 6;
    var pointSize = 12;
    var lineWidth = 1;
    var top = lineWidth/2;
    var left = lineWidth/2;
    var right = w - lineWidth/2;
    var bottom = h - lineWidth/2;
    this.requestID = window.requestAnimationFrame(function () {
      ctx.beginPath();
      ctx.lineWidth = lineWidth;
      ctx.strokeStyle = '#444';
      ctx.strokeWidth = lineWidth;
      ctx.fillStyle = bg;
      switch (direction) {
        case 0 :
          ctx.moveTo(pointSize, top);
          ctx.lineTo(right - radius, top);
          ctx.quadraticCurveTo(right, top, right, radius);
          ctx.lineTo(right, bottom - radius);
          ctx.quadraticCurveTo(right, bottom, right - radius, bottom);
          ctx.lineTo(pointSize, bottom );
          ctx.lineTo(left, h / 2);
          break;
        case 1:
          ctx.moveTo(radius, top);
          ctx.lineTo(right - radius, top);
          ctx.quadraticCurveTo(right, top, right, radius);
          ctx.lineTo(right, bottom - radius);
          ctx.quadraticCurveTo(right, bottom, right - radius, bottom);
          ctx.lineTo(radius, bottom);
          ctx.quadraticCurveTo(left, bottom, left, bottom - radius);
          ctx.lineTo(left, radius);
          ctx.quadraticCurveTo(left, top, radius, top);
          break;
        case 2:
          ctx.moveTo(radius, top);
          ctx.lineTo(right - pointSize, top);
          ctx.lineTo(right, h / 2);
          ctx.lineTo(right - pointSize, bottom);
          ctx.lineTo(radius, bottom);
          ctx.quadraticCurveTo(left, bottom, left, bottom - radius);
          ctx.lineTo(left, radius);
          ctx.quadraticCurveTo(left, top, radius, top);
          break;
      }
      ctx.closePath();
      ctx.fill();
      ctx.stroke();
    });
  },

  componentDidMount: function () {
    this.paintBorder();
  },

  render: function () {
    var textPaddingRight = this.props.showMenu ? 20 : 0;
    var w = styleHelper.getWidth(this.props);
    var h = styleHelper.getHeight(this.props);
    var isEnabled = styleHelper.getPropertyValue(this.props,propConst.STATUS) === appTypes.ComStatus2.ENABLE;
    return (
      <div className="component component-PointyButton"
           style={{
        width : w,
        height : h
      }}>
        <canvas ref="ctx"
                style={{
                  position : 'absolute',
                  zIndex : 0
                }}
                width={w}
                height={h}/>
        <div style={{
          position : 'absolute',
          zIndex : 1,
          left : 0,
          textAlign : 'center',
          color :isEnabled?styleHelper.getTextColor(this.props):'#999',
          fontSize : styleHelper.getFontSize(this.props),
          fontFamily : this.props.textFontFamily,
          fontStyle : this.props.textStyles.fontStyle,
          fontWeight : this.props.textStyles.fontWeight,
          textDecoration : this.props.textStyles.textDecoration,
          width : w - textPaddingRight
        }}>
          <label style={{
                height : h,
                lineHeight : h + 'px'
            }}>
            {styleHelper.getText(this.props)}
          </label>
        </div>
        {
          this.props.showMenu && (
            <div className="menu" style={{
              top : h/2 - 2.5,
              borderTopColor : isEnabled ?'#444':'#999'
            }}></div>
          )
        }
      </div>
    );
  }
});

module.exports = PointyButton;



/** WEBPACK FOOTER **
 ** ./src/views/Components/PointyButton.jsx
 **/